import React from 'react'

type DepotMarkerIconProps = {
  fillColor?: string
  ellipseColor?: string
  pathColor?: string
  className?: string
}

export const DepotMarkerIcon: React.FC<DepotMarkerIconProps> = ({
  fillColor = '#000',
  ellipseColor = '#FFF',
  pathColor = '#000',
  className = '',
  ...props
}) => (
  <svg
    width="30"
    height="40"
    viewBox="0 0 34 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <defs>
      <filter id="dropshadow" height="130%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="2" />
        <feOffset dx="2" dy="2" result="offsetblur" />
        <feComponentTransfer>
          <feFuncA type="linear" slope="0.5" />
        </feComponentTransfer>
        <feMerge>
          <feMergeNode />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#dropshadow)">
      <path
        d="M30 15C30 21.8281 20.8594 33.9844 16.8516 39C15.8906 40.1953 14.1094 40.1953 13.1484 39C9.14063 33.9844 0 21.8281 0 15C0 6.71875 6.71875 0 15 0C23.2812 0 30 6.71875 30 15Z"
        fill={fillColor}
      />
      <ellipse
        cx="15"
        cy="14.9611"
        rx="13.125"
        ry="13.0861"
        fill={ellipseColor}
      />
    </g>
    <g clipPath="url(#clip0_1411_730)">
      <path
        d="M5 22V10L15 6L25 10V22H22V12H8V22H5ZM9 19.5H21V22H9V19.5ZM9 16.5H21V18.5H9V16.5ZM9 13H21V15.5H9V13Z"
        fill={pathColor}
      />
    </g>
    <defs>
      <clipPath id="clip0_1411_730">
        <rect width="20" height="16" fill="white" transform="translate(5 6)" />
      </clipPath>
    </defs>
  </svg>
)
